import styles from "./ExportProfitAndLossReport.module.scss";
import { useContext, useState } from "react";
import { ToastContext } from "../../../hooks/context";
import globalStyles from "../../../assets/styles/base/globalPage.module.scss";
import {
  ExcelIconV2,
  ExclamationCirlce,
  PdfIconV2,
} from "../../../assets/svgIcons";
import primaryComponents from "../../primaryComponents";
import { cleanObject } from "../../../helpers";
import { useReportMutation } from "../../../hooks/api/mutations/usePerformance";

const ExportProfitAndLossReport = ({
  closeModal,
  storeId,
  startDate,
  endDate,
}) => {
  const getProfitAndLossReport = useReportMutation();
  const [downloading, setDownloading] = useState("");
  const triggerToast = useContext(ToastContext);

  const handleDownload = (format) => {
    setDownloading(format);
    const file_format = format === "PDF" ? "pdf" : "csv";
    const payload = {
      store_id: storeId,
      start_date: startDate ? startDate.slice(0, 10) : undefined,
      end_date: endDate ? endDate.slice(0, 10) : undefined,
      file_format,
    };
    getProfitAndLossReport.mutate(cleanObject(payload), {
      onSuccess: (data) => {
        triggerToast("Profit & Loss report generated successfully!", "success");
        if (data?.data?.data?.url) {
          window.open(data.data.data.url, "_blank");
        }
        closeModal();
      },
      onSettled: () => setDownloading(""),
    });
  };
  return (
    <>
      <div>
        <h5>Profit & Loss Report</h5>
        <div
          className={`${globalStyles.cardWithBackground} card-plain`}
          style={{
            gap: "20px",
          }}
        >
          <p className="text-center">Select the format you want to download</p>

          <div className={styles.infoMessage}>
            <ExclamationCirlce
              stroke="black"
              width="22"
              height="22"
              className="mr-2"
            />
            <p className="small-text-size">
              Clicking download will first generate your P&L report before it 
              automatically downloads.
            </p>
          </div>

          <div className={styles.formatOptions}>
            <div>
              <div className={styles.formatOption}>
                <PdfIconV2 />
              </div>
              <primaryComponents.Button
                classNames={"btn btn--primary smallBtn cover"}
                onClick={() => handleDownload("PDF")}
                disabled={downloading === "PDF"}
              >
                {downloading === "PDF" ? "Downloading..." : "Download"}
              </primaryComponents.Button>
            </div>
            <div>
              <div className={styles.formatOption}>
                <ExcelIconV2 />
              </div>
              <primaryComponents.Button
                classNames={"btn btn--primary smallBtn cover"}
                onClick={() => handleDownload("Excel")}
                disabled={downloading === "Excel"}
              >
                {downloading === "Excel" ? "Downloading..." : "Download"}
              </primaryComponents.Button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default ExportProfitAndLossReport;
